import { Masonry } from '@mui/lab';
import useWindowWidth from '@/components/ChallengePortfolio/PlanningView/VisibleWeekRangeContext/useResponsiveVisibleWeeksCountCalculation/useWindowWidth';
import React from 'react';

type ResponsiveMasonryProps = {
  widthDenominator?: number;
  maxColumns?: number;
  collapsed?: boolean;
  children: NonNullable<React.ReactNode>;
};

const DEFAULT_WIDTH_DENOMINATOR = 500;
const DEFAULT_MAX_COLUMNS = Number.POSITIVE_INFINITY;

const computeGridColumnCount = (
  windowWidth: number,
  widthDenominator: number,
): number => {
  const columnCount = Math.floor(windowWidth / widthDenominator);

  if (widthDenominator > 300) {
    return Math.max(windowWidth <= 640 ? 2 : 1, columnCount);
  }

  return Math.max(1, columnCount);
};

// eslint-disable-next-line react-refresh/only-export-components
export const useGridColumnCount = (
  widthDenominator: number = DEFAULT_WIDTH_DENOMINATOR,
  maxColumns: number = DEFAULT_MAX_COLUMNS,
): number => {
  const windowWidth = useWindowWidth();

  const gridColumnCount = computeGridColumnCount(windowWidth, widthDenominator);

  return Math.min(maxColumns ?? DEFAULT_MAX_COLUMNS, gridColumnCount);
};

const ResponsiveMasonry = ({
  widthDenominator,
  maxColumns,
  collapsed,
  children,
}: ResponsiveMasonryProps) => {
  const gridColumnCount = useGridColumnCount(
    widthDenominator ?? DEFAULT_WIDTH_DENOMINATOR,
    maxColumns ?? DEFAULT_MAX_COLUMNS,
  );

  return (
    <Masonry columns={collapsed ? 0 : gridColumnCount}>{children}</Masonry>
  );
};

export default ResponsiveMasonry;
